/**
 * Sub-componente reusável: Empresa + Funcionário.
 * Usado nos forms de S-2200/2205/2206/2230/2298.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import Autocomplete from '../../ui/autocomplete';

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function EmpresaFuncionarioSelect({
  companyId, employeeId, onChange,
  hideFuncionario = false,
  regime,
  testidEmpresa = 'esocial-empresa-select',
  testidFuncionario = 'esocial-funcionario-select',
}) {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/api/companies`, auth())
      .then(r => {
        const data = r.data || [];
        setCompanies(data);
        if (data.length === 0) toast.error('Nenhuma empresa encontrada');
      })
      .catch(() => {
        setCompanies([]);
        toast.error('Erro ao carregar empresas');
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="col-span-2">
        <Label>Empresa *</Label>
        <Select value={companyId || ''} onValueChange={v => onChange({ company_id: v, employee_id: '' })}>
          <SelectTrigger data-testid={testidEmpresa}><SelectValue placeholder={loading ? 'Carregando...' : 'Selecione a empresa...'} /></SelectTrigger>
          <SelectContent>
            {companies.length === 0 && !loading && (
              <div className="px-2 py-4 text-center text-xs text-slate-500">Nenhuma empresa disponível</div>
            )}
            {companies.map(c => (
              <SelectItem key={c.id} value={c.id}>
                {c.name || c.razao_social} {c.cnpj ? ` · CNPJ ${c.cnpj}` : ''}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {!hideFuncionario && (
        <div className="col-span-2">
          <Label>Funcionário *</Label>
          <Autocomplete
            value={employeeId || ''}
            onValueChange={(value, item) => onChange({
              company_id: companyId,
              employee_id: value,
              cpf_trab: (item?.cpf || '').replace(/\D/g, ''),
            })}
            endpoint={`${API}/api/employees-paged`}
            searchParam="search"
            getOptionLabel={(item) => `${item.nome}${item.cpf ? ` · CPF ${item.cpf}` : ''}${item.cargo ? ` · ${item.cargo}` : ''}`}
            getOptionValue={(item) => item.id}
            placeholder={companyId ? 'Digite o nome, CPF ou cargo...' : 'Selecione a empresa primeiro'}
            extraParams={{ active_only: true, ...(companyId ? { company_id: companyId } : {}), ...(regime ? { regime } : {}) }}
            emptyMessage="Nenhum funcionário encontrado"
          />
        </div>
      )}
    </>
  );
}
